import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDlZthQNuuFm047ZHWYL1cV7ljv1DshnIM",
  authDomain: "svmd-admin.firebaseapp.com",
  projectId: "svmd-admin",
  storageBucket: "svmd-admin.firebasestorage.app",
  messagingSenderId: "466983532481",
  appId: "1:466983532481:web:f2c3dfda211cbb2ed52140",
  measurementId: "G-WNX1YPZVH4"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
